<script lang="ts" setup>
import type { NuxtError } from "#app";
import * as Sentry from "@sentry/nuxt";

const props = defineProps<{
  error: NuxtError;
}>();

const AVAILABLE_ERRORS = [404];

if (!AVAILABLE_ERRORS.includes(props.error.statusCode)) {
  Sentry.captureException(props.error, {
    extra: {
      statusCode: props.error.statusCode,
      statusMessage: props.error.statusMessage
    }
  });
}
</script>

<template>
  <BackgroundAuth />
  <section>
    <div v-if="error.statusCode == 404">
      <Errors404 />
    </div>
    <div v-if="!AVAILABLE_ERRORS.includes(error.statusCode)">
      Error {{ error.statusCode }}: {{ error.statusMessage }}
    </div>
  </section>
</template>

<style lang="scss" scoped></style>
